export default "__VITE_ASSET__Db4AiF1f__"